var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"100%"}},[_c('img',{staticClass:"oeos-loader-center",attrs:{"src":_vm.loadingImage}}),_c('div',{staticClass:"oeos-loader-center"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }